<template>
  <div>
    <div v-show="load" class="edit-main">
      <Title/>
      <div class="row justify-content-center" :class="viewData.wrapClass">
        <div class="col-xl-10">
          <form class="edit align-items-center bg-gray" :class="viewData.formClass">
            <component :is="viewData.component"
                       :viewData="viewData.componentData"
                       :prev="viewData.prev"
                       :class="viewData.componentClass"
                       @loadTrue="load = true"
            />
            <div class="edit__wrap edit__buttons">
              <CustomButton class="btn btn--blue btn--big btn--no-transform" @click="change">
                {{viewData.btnText}}
              </CustomButton>
              <router-link :to="{name: viewData.prev}" class="btn btn--black btn--no-transform">Отмена</router-link>
            </div>
          </form>
        </div>
      </div>
    </div>
    <Loader v-show="!load"/>
  </div>
</template>

<script>
  import Title from "../components/Title";
  import EditImg from "../components/edit/EditImg";
  import EditInputs from "../components/edit/EditInputs";
  import EditText from "../components/edit/EditText";
  import Loader from "../components/Loader";
  import CustomButton from "../components/CustomButton";
  export default {
    name: "Edit",
    components: {CustomButton, Loader, EditText, EditInputs, EditImg, Title},
    data() {
      return {
        viewData: this.$store.state[this.$route.meta.viewData[0]][this.$route.meta.viewData[1]],
        load: false
      }
    },
    methods: {
      change() {
        this.$children[1].validate();
      }
    }
  }
</script>

<style lang="scss">
  @import "../style/var";

  .edit {
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 540px;
    padding: 40px 50px;
    @media (max-width: 575px) {
      margin-top: 30px;
      width: calc(100% + 30px);
      margin-left: -15px;
    }
    &-main {
      margin-bottom: 60px;
      @media (max-width: 575px) {
        margin-bottom: 0;
      }
    }
    &--small {
      min-height: 485px;
    }
    &--no-height {
      min-height: unset;
    }
    &__wrap {
      width: 425px;
      max-width: 100%;
    }
    &__buttons {
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      @media(max-width: 767px) {
        flex-direction: column;
        align-items: center;
        .btn {
          width: 100%;
          &:first-of-type {
            margin-bottom: 20px;
          }
          &.btn--black {
            width: unset;
            margin-top: 10px;
            color: $blue;
            background-color: transparent;
          }
        }
      }
    }
    &__text {
      display: flex;
      flex-direction: column;
    }
  }
</style>